import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private products = [
    {
      id: 4,
      name: 'Grilled Chicken Sandwich',
      category: ['Fast Food', 'Dinner'],
      countryOffer: ['china', 'belgium', 'france'],
      price: 9.49,
      isFeatured: false,
      cookingTime: 15,
      ranking: 5,
      image:
        'https://heygrillhey.com/wp-content/uploads/2024/01/CSCS-Square.jpg',
      description:
        "A healthy grilled chicken sandwich that brings together fresh, tender chicken, crisp lettuce, juicy tomatoes, and a soft, lightly toasted bun. The chicken is seasoned to perfection, giving each bite a smoky, flavorful kick. Ideal for those who prefer a lighter meal without compromising on taste. This sandwich offers a balanced mix of protein and vegetables, making it a perfect lunch or dinner option. Whether you're on the go or enjoying a relaxing meal, it satisfies both hunger and health-conscious cravings.",
    },
    {
      id: 5,
      name: 'Caesar Salad',
      category: ['Dinner', 'Healthy'],
      countryOffer: ['china', 'south Korea'],
      price: 7.99,
      isFeatured: true,
      cookingTime: 10,
      ranking: 4,
      image:
        'https://img.freepik.com/premium-photo/caesar-salad-dark-background_732812-2249.jpg',
      description:
        'Crisp romaine lettuce is topped with crunchy croutons, parmesan cheese, and a rich Caesar dressing that ties all the ingredients together. This salad is both light and flavorful, providing the perfect balance of textures and flavors. The sharpness of the cheese and the crunch of the croutons elevate the freshness of the greens. This dish is ideal for anyone seeking a healthy yet satisfying meal. You can enjoy it as a side dish or pair it with your favorite protein for a complete meal. A classic favorite for any time of the day.',
    },
    {
      id: 1,
      name: 'Margherita Pizza',
      category: ['Fast Food', 'Lunch'],
      countryOffer: ['china', 'italy', 'france'],
      price: 12.99,
      isFeatured: false,
      cookingTime: 20,
      ranking: 4.5,
      image:
        'https://t4.ftcdn.net/jpg/08/79/46/99/360_F_879469903_n9dpcOST1Rt2YfBLsbIiIfiM8iVipZHn.jpg',
      description:
        "A classic pizza made with fresh mozzarella, tangy tomato sauce, and a sprinkle of basil. This pizza features a thin, crispy crust topped with high-quality ingredients for a simple yet delicious taste. Perfect for anyone who loves the authentic Italian flavors. Its bright, fresh taste is balanced by the richness of the cheese and the hint of basil, making it a crowd favorite. Whether you're enjoying a cozy night in or hosting a pizza party, this pizza will never disappoint. A truly timeless choice that never goes out of style.",
    },
    {
      id: 6,
      name: 'Spaghetti Carbonara',
      category: ['Pasta', 'Dinner'],
      countryOffer: ['Belgium', 'italy', 'france'],
      price: 13.99,
      cookingTime: 25,
      ranking: 4,
      image:
        'https://www.sipandfeast.com/wp-content/uploads/2022/09/spaghetti-carbonara-recipe-snippet.jpg',
      description:
        "This Italian classic features al dente pasta tossed with crispy pancetta, a creamy egg mixture, and a generous sprinkle of parmesan cheese. The creamy sauce clings perfectly to the noodles, while the pancetta adds a savory, smoky flavor that contrasts beautifully with the richness of the egg mixture. It’s a comforting, indulgent dish with deep flavors that make every bite satisfying. A perfect choice for dinner, especially if you're craving a hearty, warm meal. Whether you’re making it for a family gathering or a cozy evening, it’s sure to impress.",
    },
    {
      id: 6,
      name: 'Cheese Pasta',
      category: ['Pasta'],
      countryOffer: ['Belgium', 'italy', 'france'],
      price: 13.99,
      isFeatured: true,
      cookingTime: 25,
      ranking: 4,
      image:
        'https://c0.wallpaperflare.com/preview/734/800/58/basil-cheese-close-up-cook-thumbnail.jpg',
      description:
        "This Italian classic features al dente pasta tossed with crispy pancetta, a creamy egg mixture, and a generous sprinkle of parmesan cheese. The creamy sauce clings perfectly to the noodles, while the pancetta adds a savory, smoky flavor that contrasts beautifully with the richness of the egg mixture. It’s a comforting, indulgent dish with deep flavors that make every bite satisfying. A perfect choice for dinner, especially if you're craving a hearty, warm meal. Whether you’re making it for a family gathering or a cozy evening, it’s sure to impress.",
    },
    {
      id: 7,
      name: 'Chicken Tikka Masala',
      category: ['Dinner'],
      countryOffer: ['Middke East', 'italy', 'france'],
      price: 14.99,
      isFeatured: true,
      cookingTime: 30,
      ranking: 4,
      image:
        'https://www.kitchensanctuary.com/wp-content/uploads/2015/09/Spicy-Beef-Curry-square-600x600.jpg',
      description:
        "Tender chicken cooked in a rich, flavorful tomato-based sauce, spiced with garam masala and other Indian spices, creates a mouth-watering dish that’s both aromatic and comforting. This dish is known for its creamy texture and perfectly balanced flavors, with just the right amount of heat and sweetness. It's an iconic curry that pairs beautifully with naan bread or rice. The spices blend together to create an unforgettable taste that lingers long after the meal is finished. Whether you're a fan of Indian cuisine or new to it, this dish is a must-try.",
    },
    {
      id: 8,
      name: 'Veggie Wrap',
      category: ['Healthy', 'Lunch'],
      countryOffer: ['Indian', 'UK', 'france'],
      price: 6.99,
      isFeatured: false,
      cookingTime: 10,
      ranking: 4.5,
      image:
        'https://www.culinaryhill.com/wp-content/uploads/2023/08/Ultimate-Veggie-Wrap-Culinary-Hill-1200x800-1-500x375.jpg',
      description:
        "A wholesome wrap filled with fresh vegetables, hummus, and a variety of greens, making it a nutritious and delicious meal. This wrap is perfect for anyone looking to add more veggies to their diet without compromising on taste. The creamy hummus adds a rich texture, while the crisp vegetables offer a refreshing crunch. Whether you're vegan, vegetarian, or simply looking for a lighter lunch, this wrap is both satisfying and healthy. It’s a quick, convenient option for those on the go or for a lighter meal option.",
    },
    {
      id: 2,
      name: 'Cheese Burger',
      category: ['Fast Food', 'Lunch'],
      countryOffer: ['korea', 'italy', 'Russia'],
      price: 8.99,
      cookingTime: 15,
      isFeatured: false,
      ranking: 4,
      image:
        'https://leitesculinaria.com/wp-content/uploads/2020/02/classic-cheeseburger-1200.jpg',
      description:
        'A juicy beef patty topped with melted cheese, fresh lettuce, and tomatoes, all sandwiched between a soft, toasted bun. This classic burger is the ultimate comfort food, offering a perfect balance of savory flavors. The beef patty is grilled to perfection, providing a tender and juicy bite every time. The cheese melts beautifully over the patty, creating a rich, flavorful experience. Paired with crunchy lettuce and ripe tomatoes, it becomes a delicious combination of textures. A must-try for burger lovers, it’s perfect for lunch or dinner.',
    },
    {
      id: 3,
      name: 'Tomato Soup',
      category: ['Soup', 'Healthy'],
      countryOffer: ['china', 'italy', 'france'],
      price: 5.99,
      cookingTime: 10,
      isFeatured: true,
      ranking: 4.5,
      image:
        'https://www.indianhealthyrecipes.com/wp-content/uploads/2022/11/tomato-soup-recipe.jpg',
      description:
        'A warm and comforting tomato soup, made with ripe, juicy tomatoes and seasoned with fresh basil. The soup is creamy and rich, with a smooth texture that makes every spoonful a comforting experience. It’s a simple, yet flavorful dish, perfect for a chilly day or as a starter for a more substantial meal. The subtle sweetness of the tomatoes blends perfectly with the aromatic basil, making this soup both hearty and refreshing. Ideal when served with a slice of toasted bread or grilled cheese. A classic comfort food for all ages.',
    },
    {
      id: 8,
      name: 'Lentil Soup',
      category: ['Soup'],
      countryOffer: ['india', 'middle-east'],
      price: 6.99,
      cookingTime: 25,
      isFeatured: true,
      ranking: 4.5,
      image:
        'https://thumbs.dreamstime.com/b/sushi-bowl-lentil-soup-dark-black-orange-neo-geo-style-295606284.jpg',
      description:
        'A hearty and comforting lentil soup made with a variety of lentils, tomatoes, and spices. This dish is high in protein and fiber, making it a perfect option for a filling and nutritious meal. The mild spices and tender lentils create a satisfying bowl of goodness that is great for any time of the year.',
    },
    {
      id: 9,
      name: 'Chicken Noodle Soup',
      category: ['Soup'],
      countryOffer: ['usa', 'canada'],
      price: 7.49,
      cookingTime: 20,
      ranking: 4.5,
      image:
        'https://www.theslowroasteditalian.com/wp-content/uploads/2021/11/Slow-Cooker-Chicken-Noodle-Soup-SQUARE-500x500.jpg',
      description:
        'A classic, comforting chicken noodle soup filled with tender chicken, noodles, and vegetables in a flavorful, aromatic broth. This soup is perfect for chilly days or when you need something warm and comforting. Packed with nutrients and easy to make, it’s a go-to option for a quick and delicious meal.',
    },
    {
      id: 10,
      name: 'Minestrone Soup',
      category: ['Soup'],
      isFeatured: false,
      countryOffer: ['italy'],
      price: 7.99,
      cookingTime: 30,
      ranking: 4,
      image:
        'https://thecozycook.com/wp-content/uploads/2023/09/Minestrone-Soup-f.jpg',
      description:
        'A hearty Italian minestrone soup filled with seasonal vegetables, beans, and pasta, all simmered together in a rich, flavorful broth. This soup is a nutritious, filling dish that is perfect as a main course. Full of flavor and packed with healthy ingredients, minestrone is a classic soup that can be enjoyed by everyone.',
    },
    {
      id: 11,
      name: 'Butternut Squash',
      category: ['Dessert'],
      countryOffer: ['usa', 'france'],
      price: 8.49,
      cookingTime: 35,
      ranking: 5,
      image:
        'https://www.shutterstock.com/image-photo/decadent-strawberry-cheesecake-topped-vibrant-600nw-2486100037.jpg',
      description:
        'A smooth and creamy butternut squash soup that’s perfect for the fall and winter months. Made with roasted butternut squash, onions, and a hint of nutmeg and cinnamon, this soup is both savory and slightly sweet. It’s a delicious, comforting vegan option that pairs wonderfully with a slice of crusty bread.',
    },
    {
      id: 9,
      name: 'Potato Steak',
      category: ['Dinner'],
      isFeatured: false,
      countryOffer: ['USA', 'italy', 'france'],
      price: 19.99,
      cookingTime: 35,
      ranking: 5,
      image:
        'https://marleyspoon.com/media/recipes/41516/main_photos/large/rosemary-9fa87dfbd25f7153e03fffb490a9ba7c.jpeg',
      description:
        'Golden-brown roasted potato steak with a crispy outer layer and a soft, tender interior. Each slice of potato is perfectly seasoned, ensuring every bite is full of flavor. This dish can be enjoyed on its own or served as a side to complement any meal. The potatoes are carefully roasted to achieve the perfect balance of texture, with a crispy crust and a melt-in-your-mouth interior. It’s a comforting, hearty dish that’s perfect for any occasion, whether as a main dish or side dish for a more substantial meal.',
    },
    {
      id: 10,
      name: 'French Fries',
      category: ['Fast Food'],
      countryOffer: ['france', 'belgium', 'italy'],
      price: 4.99,
      isFeatured: false,
      cookingTime: 8,
      ranking: 4.5,
      image: 'https://static.toiimg.com/photo/53110049.cms',
      description:
        'Crispy golden French fries, seasoned with a pinch of salt, are a beloved side dish enjoyed around the world. These fries are perfectly fried to achieve a satisfying crunch on the outside, while remaining soft and fluffy on the inside. Whether you’re pairing them with a burger, sandwich, or enjoying them on their own, they are the ultimate comfort food. A classic favorite that’s loved by all ages, they offer just the right amount of saltiness. Perfect for snacking or as a side to any meal, they’re always a crowd pleaser.',
    },
    {
      id: 11,
      name: 'Chocolate Cake',
      category: ['Dessert'],
      countryOffer: ['china', 'italy', 'france'],
      price: 6.99,
      cookingTime: 25,
      ranking: 4,
      image:
        'https://img.freepik.com/free-photo/chocolate-cake-with-nuts-top-view_114579-651.jpg',
      description:
        'A rich and indulgent chocolate cake topped with creamy frosting and sprinkled with crunchy nuts. Each bite of this decadent dessert is a burst of chocolatey goodness, offering a deep, satisfying flavor. The moist cake pairs perfectly with the smooth, velvety frosting, making it a treat for any chocolate lover. The added nuts bring a delightful crunch, balancing the richness of the cake. It’s the perfect dessert to end any meal, whether for a celebration or just a sweet treat after dinner. A must-have for those with a sweet tooth.',
    },
    {
      id: 11,
      name: 'Milk Shake',
      category: ['Dessert'],
      countryOffer: ['italy', 'france', 'Europe'],
      price: 6.99,
      cookingTime: 25,
      ranking: 4,
      image:
        'https://static.vecteezy.com/system/resources/previews/034/039/975/non_2x/three-tasty-fresh-milk-shakes-with-berries-and-mint-on-black-table-generated-by-artificial-intelligence-free-photo.jpg',
      description:
        'A rich and indulgent Milk Shake topped with creamy frosting and sprinkled with crunchy nuts. Each bite of this decadent dessert is a burst of chocolatey goodness, offering a deep, satisfying flavor. The moist cake pairs perfectly with the smooth, velvety frosting, making it a treat for any chocolate lover. The added nuts bring a delightful crunch, balancing the richness of the cake. It’s the perfect dessert to end any meal, whether for a celebration or just a sweet treat after dinner. A must-have for those with a sweet tooth.',
    },
    {
      id: 11,
      name: 'Chocalate Oreo Shake',
      category: ['Dessert'],
      countryOffer: ['Aussie', 'france', 'Europe'],
      price: 6.99,
      cookingTime: 25,
      ranking: 4,
      image:
        'https://thumbs.dreamstime.com/b/oreo-milkshake-chocolate-syrup-ore-323302537.jpg',
      description:
        'A rich and indulgent Milk Shake topped with creamy frosting and sprinkled with crunchy nuts. Each bite of this decadent dessert is a burst of chocolatey goodness, offering a deep, satisfying flavor. The moist cake pairs perfectly with the smooth, velvety frosting, making it a treat for any chocolate lover. The added nuts bring a delightful crunch, balancing the richness of the cake. It’s the perfect dessert to end any meal, whether for a celebration or just a sweet treat after dinner. A must-have for those with a sweet tooth.',
    },
    {
      id: 12,
      name: 'Fish and Chips',
      isFeatured: true,
      category: ['Pasta', 'Lunch'],
      countryOffer: ['belgium', 'italy', 'france'],
      price: 14.49,
      cookingTime: 20,
      ranking: 4.5,
      image:
        'https://www.sbfoods-worldwide.com/recipes/eaq25q0000003y2c-img/6_Fish&ChipsSauce.jpg',
      description:
        'Crispy battered fish served with golden fries, this British classic offers a satisfying and flavorful meal. The fish is coated in a light, crispy batter that holds up perfectly, while the inside remains flaky and tender. Paired with golden fries that are crispy on the outside and soft on the inside, this dish is a comfort food favorite. A drizzle of tartar sauce or a squeeze of lemon elevates the flavor even further. Whether for a casual lunch or dinner, this dish is sure to please anyone who loves seafood and classic comfort food.',
    },
  ];

  constructor() {}

  getProducts() {
    return this.products;
  }

  getProductById(id: string) {
    // Convert the id from string to number for comparison if needed
    return this.products.find((product) => product.id === Number(id));
  }
}
